import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb, BreadcrumbItem, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useLocation, Link } from "react-router-dom";
import Select from "react-select";
import { Home } from "react-feather";
import AsyncSelect from 'react-select/async';
import axios from "axios";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import { KIBANA_PLM_URL, KIBANA_PLM_INTERNAL_URL } from "../../Common/KibanaAPIEndpoints/KibanaAPIEndpoints";

import { useKibanaAuthentication } from "../../hooks/useKibanaAuthentication";

export default function AjaxIntializationTime() {

  const { setToken } = useKibanaAuthentication();

  const [loading, setLoading] = useState(true)

  const search = useLocation().search;
  const commit = new URLSearchParams(search).get("commit");
  const searchParams = {
    siteName: new URLSearchParams(search).get("filter[site_name]"),
    time: new URLSearchParams(search).get("filter[time]"),
    seleniumCluster: new URLSearchParams(search).get("filter[selenium_cluster]"),
    tabName: new URLSearchParams(search).get("filter[tab_name]")
  }
  const [siteName, setSiteName] = useState({ label: 'All', value: 'all' });
  const [siteNameOptions, setSiteNameOptions] = useState([]);
  const [time, setTime] = useState({ label: 'Last 4 hours', value: 'now-4h' });
  const [seleniumCluster, setSeleniumCluster] = useState({ label: 'All', value: 'all' });
  const [seleniumOptions, setSeleniumOptions] = useState([]);
  const [activeTab, setActiveTab] = useState('1');
  const [urlParams, setUrlParams] = useState({
    siteName: '*',
    seleniumCluster: '*',
    time: 'now-4h'
  })
  const timeOptions = [
    { label: 'Today', value: 'now%2Fd' },
    { label: 'Last 30 minutes', value: 'now-30m' },
    { label: 'Last 1 hour', value: 'now-1h' },
    { label: 'Last 2 hours', value: 'now-2h' },
    { label: 'Last 4 hours', value: 'now-4h' },
    { label: "Last 10 hours", value: "now-10h" },
    { label: 'Last 12 hours', value: 'now-12h' },
    { label: 'Last 24 hours', value: 'now-24h' },
    { label: 'Last 2 days', value: 'now-2d' },
    { label: 'Last 3 days', value: 'now-3d' },
    { label: 'Last 4 days', value: 'now-4d' },
    { label: 'Last 7 days', value: 'now-7d' },
    { label: 'Last 15 days', value: 'now-15d' },
    { label: 'Last 30 days', value: 'now-30d' },
    { label: 'Last 60 days', value: 'now-60d' },
    { label: 'Last 1 year', value: 'now-1y' }
  ];

  useEffect(() => {
    setSearchParamsData();

    async function fetchInitialData() {
      try {
        setLoading(true);
        await setToken(KIBANA_PLM_URL)
        const res = await axios.get('/api/v1/internal/dropdown_list_helper')
        let site_names = res.data.site_names, site_names_options = []
        for (var key in site_names) {
          let group = {}, children = []
          group['label'] = <div className="fw-bold col text-black">{key}</div>
          site_names[key].map(item => {
            children.push({ label: item, value: item })
          })
          group['options'] = children;
          site_names_options.push(group)
        }
        site_names_options.push({ label: <div className="fw-bold text-black">All</div>, options: [{ label: 'All', value: 'all' }] })
        setSiteNameOptions(site_names_options);
        let result = res.data.geo_clusters.map(item => ({ label: item, value: item }));
        result.push({ label: 'All', value: 'all' })
        setSeleniumOptions(result);

      } catch (err) {
        console.error("Failed to fetch data", err);
      } finally {
        setLoading(false);
      }
    }

    fetchInitialData();
  }, []);

  function setSearchParamsData() {
    console.log(searchParams, 'params')
    if (searchParams.siteName && searchParams.siteName != siteName.value) {
      setSiteName({ label: searchParams.siteName == 'all' ? 'All' : searchParams.siteName, value: searchParams.siteName });
    }
    if (searchParams.seleniumCluster && searchParams.seleniumCluster != seleniumCluster.value) {
      setSeleniumCluster({ label: searchParams.seleniumCluster == 'all' ? 'All' : searchParams.seleniumCluster, value: searchParams.seleniumCluster });
    }
    if (searchParams.time && searchParams.time != time.value) {
      setTime(timeOptions.filter(item => searchParams.time == item.value)[0])
    }
    if (searchParams.tabName) {
      setActiveTab(searchParams.tabName == 'overall_avg_ajax_init_time' ? '2' : '1')
    }
    if (commit == 'Get Data' && searchParams.seleniumCluster && searchParams.siteName && searchParams.time) {
      setUrlParams(searchParams)
    }
  }

  const handleGetData = () => {
    window.location.href = `/internal/selenium/ajax_initialization_time?filter[site_name]=${siteName.value}&filter[selenium_cluster]=${seleniumCluster.value}&filter[time]=${time.value}&filter[tab_name]=${activeTab == '2' ? 'overall_avg_ajax_init_time' : ''}&commit=${'Get Data'}`
  }

  const promiseOptions = (inputValue) => {
    if (inputValue.length < 3) {
      return null
    } else {
      return new Promise((resolve) => {
        axios.get(`/api/v1/internal/search_site_names?site_name=${inputValue}`).then(res => {
          if (res.status == '200') {
            let site_names = res.data.site_names, site_names_options = []
            for (var key in site_names) {
              let group = {}, children = []
              group['label'] = <div className="fw-bold col text-black">{key}</div>
              site_names[key].map(item => {
                children.push({ label: item, value: item })
              })
              group['options'] = children;
              site_names_options.push(group)
            }
            site_names_options.push({ label: <div className="fw-bold text-black">All</div>, options: [{ label: 'All', value: 'all' }] })
            setSiteNameOptions(site_names_options)
            resolve(site_names_options)
          }
        }).catch(err => {
          console.log(`err`, err)
        })
      })
    }
  }

  if(loading) {
    return (
      <Loader type="Puff" color="#00BFFF" height={100} width={100} className='pc-loader' />
    )
  }

  return <Container fluid>
    <div className="page-title">
      <Row className=''>
        <Col xs="6">
          <h3>Internal Dashboard</h3>
        </Col>
        <Col xs="6">
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to={'/internal'}>
                <Home />
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              {commit == 'Get Data' ? <a href={'/internal/selenium/ajax_initialization_time'}>Ajax Initialization Time</a> : 'Ajax Initialization Time'}
            </BreadcrumbItem>
            {commit == 'Get Data' && <BreadcrumbItem className="fw-bold">
              Search Results
            </BreadcrumbItem>}
          </Breadcrumb>
        </Col>
      </Row>
    </div>
    <Card>
      <CardBody>
        <Row>
          <Col sm="8">
            <label className="fw-bold">Site Name</label>
            <AsyncSelect cacheOptions defaultOptions={siteNameOptions} name='site_name'
              value={siteName} loadOptions={promiseOptions} onChange={res => setSiteName(res)}
              placeholder="Select a site name" />
            <p><i>Please type atleast 3 characters while searching the sitename!</i></p>
          </Col>
        </Row>
        <Row className="align-items-end mt-2">
          <Col sm="4">
            <label className="fw-bold">Selenium Cluster</label>
            <Select
              value={seleniumCluster}
              options={seleniumOptions}
              onChange={option => setSeleniumCluster(option)} />
          </Col>
          <Col sm="4">
            <label className="fw-bold">Time</label>
            <Select
              value={time}
              options={timeOptions}
              onChange={option => setTime(option)} />
          </Col>
          <Col sm="4">
            <button className="btn btn-success w-100" onClick={handleGetData}>Get Data</button>
          </Col>
        </Row>
      </CardBody>
    </Card>
    <Card>
      <CardBody>
        <div className="mb-1">
          <b>NOTE:</b>
          If the graph is not shown after your form submission then you should do either maximize its size(the option is available on the right side of graph) or minimize the sidebar.
        </div>
        <Nav tabs>
          <NavItem>
            <NavLink className={activeTab == '1' ? 'active' : ''} onClick={() => setActiveTab('1')} >
              Ajax Driver Initialization Time Vs Site
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab == '2' ? 'active' : ''} onClick={() => setActiveTab('2')} >
              Overall Average Ajax Initialization Time
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={'1'}>
            <center className="mt-3">
              <span className="fw-bold pb-1">Ajax Driver Initialization Time Vs Site</span><br />

              <a target="_blank" className="link-primary" href={`${KIBANA_PLM_INTERNAL_URL}app/kibana#/visualize/create?type=histogram&indexPattern=8c44ed90-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:${urlParams.time},mode:quick,to:${urlParams.time == 'now%2Fd' ? 'now%2Fd' : 'now'}))&_a=(filters:!(),linked:!f,query:(language:kuery,query:'selenium_cluster.raw+:${urlParams.seleniumCluster == 'all' ? '*' : urlParams.seleniumCluster}+and+site_name.raw+:${urlParams.siteName == 'all' ? '*' : urlParams.siteName}+'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(field:ajax_init_time),schema:metric,type:avg),(enabled:!t,id:'2',params:(field:site_name.raw,missingBucket:!f,missingBucketLabel:Missing,order:desc,orderBy:'1',otherBucket:!f,otherBucketLabel:Other,size:20),schema:segment,type:terms),(enabled:!t,id:'3',params:(field:site_name.raw,missingBucket:!f,missingBucketLabel:Missing,order:desc,orderBy:'1',otherBucket:!f,otherBucketLabel:Other,size:20),schema:group,type:terms),(enabled:!t,id:'4',params:(filters:!((input:(query:'file_name:%22selenium_diskfetcher_module_v2.rb%22'),label:'')),row:!t),schema:split,type:filters)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),defaultYExtents:!f,grid:(categoryLines:!f),labels:(show:!f),legendPosition:right,mode:stacked,scale:linear,seriesParams:!((data:(id:'1',label:'Average+ajax_init_time'),lineWidth:2,mode:stacked,show:!t,type:histogram,valueAxis:ValueAxis-1)),setYExtents:!f,shareYAxis:!t,thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:histogram,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(boundsMargin:0,defaultYExtents:!f,mode:normal,setYExtents:!f,type:linear),show:!t,style:(),title:(text:Count),type:value)),yAxis:()),title:'Internal+Dashboard+-+Ajax+Init+Time+Average+vs+Sites',type:histogram))`}>Click here to see below graph in kibana</a>
            </center>
            <iframe src={`${KIBANA_PLM_URL}app/kibana#/visualize/create?type=histogram&indexPattern=8c44ed90-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:${urlParams.time},mode:quick,to:${urlParams.time == 'now%2Fd' ? 'now%2Fd' : 'now'}))&_a=(filters:!(),linked:!f,query:(language:kuery,query:'selenium_cluster.raw+:${urlParams.seleniumCluster == 'all' ? '*' : urlParams.seleniumCluster}+and+site_name.raw+:${urlParams.siteName == 'all' ? '*' : urlParams.siteName}+'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(field:ajax_init_time),schema:metric,type:avg),(enabled:!t,id:'2',params:(field:site_name.raw,missingBucket:!f,missingBucketLabel:Missing,order:desc,orderBy:'1',otherBucket:!f,otherBucketLabel:Other,size:20),schema:segment,type:terms),(enabled:!t,id:'3',params:(field:site_name.raw,missingBucket:!f,missingBucketLabel:Missing,order:desc,orderBy:'1',otherBucket:!f,otherBucketLabel:Other,size:20),schema:group,type:terms),(enabled:!t,id:'4',params:(filters:!((input:(query:'file_name:%22selenium_diskfetcher_module_v2.rb%22'),label:'')),row:!t),schema:split,type:filters)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),defaultYExtents:!f,grid:(categoryLines:!f),labels:(show:!f),legendPosition:right,mode:stacked,scale:linear,seriesParams:!((data:(id:'1',label:'Average+ajax_init_time'),lineWidth:2,mode:stacked,show:!t,type:histogram,valueAxis:ValueAxis-1)),setYExtents:!f,shareYAxis:!t,thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:histogram,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(boundsMargin:0,defaultYExtents:!f,mode:normal,setYExtents:!f,type:linear),show:!t,style:(),title:(text:Count),type:value)),yAxis:()),title:'Internal+Dashboard+-+Ajax+Init+Time+Average+vs+Sites',type:histogram))&embed=true`} height="800" width="100%" className="border-0"></iframe>
          </TabPane>
          <TabPane tabId={'2'}>
            <center className="mt-3">
              <span className="fw-bold">Overall Average Ajax Initialization Time</span><br />

              <a target="_blank" className="link-primary" href={`${KIBANA_PLM_INTERNAL_URL}app/kibana#/visualize/create?type=line&indexPattern=8c44ed90-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:${urlParams.time},mode:quick,to:${urlParams.time == 'now%2Fd' ? 'now%2Fd' : 'now'}))&_a=(filters:!(),linked:!f,query:(language:kuery,query:'selenium_cluster.raw:${urlParams.seleniumCluster == 'all' ? '*' : urlParams.seleniumCluster}+AND+site_name.raw:${urlParams.siteName == 'all' ? '*' : urlParams.siteName}'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(field:ajax_init_time),schema:metric,type:avg),(enabled:!t,id:'2',params:(drop_partials:!f,extended_bounds:(),field:'@timestamp',interval:h,min_doc_count:1,scaleMetricValues:!f,timeRange:(from:${urlParams.time},to:${urlParams.time == 'now%2Fd' ? 'now%2Fd' : 'now'}),useNormalizedEsInterval:!t),schema:segment,type:date_histogram),(enabled:!t,id:'3',params:(filters:!((input:(query:'file_name:%22selenium_diskfetcher_module_v2.rb%22'),label:''))),schema:group,type:filters)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),defaultYExtents:!f,dimensions:(series:!((accessor:1,aggType:filters,format:(),params:())),x:(accessor:0,aggType:date_histogram,format:(id:date,params:(pattern:'HH:mm')),params:(bounds:(max:'2021-09-27T11:39:18.587Z',min:'2021-09-27T07:39:18.587Z'),date:!t,format:'HH:mm',interval:PT5M,intervalESUnit:m,intervalESValue:5)),y:!((accessor:2,aggType:avg,format:(id:number),params:()))),drawLinesBetweenPoints:!t,grid:(categoryLines:!f),interpolate:linear,labels:(),legendPosition:right,radiusRatio:9,scale:linear,seriesParams:!((data:(id:'1',label:'Average+ajax_init_time'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,radiusRatio:9,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1)),setYExtents:!f,shareYAxis:!t,showCircles:!t,smoothLines:!f,thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:line,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(boundsMargin:0,defaultYExtents:!f,mode:normal,setYExtents:!f,type:linear),show:!t,style:(),title:(text:Count),type:value)),yAxis:()),title:'',type:line))`}>Click here to see below graph in kibana</a>
            </center>
            <iframe src={`${KIBANA_PLM_URL}app/kibana#/visualize/create?type=line&indexPattern=8c44ed90-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:${urlParams.time},mode:quick,to:${urlParams.time == 'now%2Fd' ? 'now%2Fd' : 'now'}))&_a=(filters:!(),linked:!f,query:(language:kuery,query:'selenium_cluster.raw:${urlParams.seleniumCluster == 'all' ? '*' : urlParams.seleniumCluster}+AND+site_name.raw:${urlParams.siteName == 'all' ? '*' : urlParams.siteName}'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(field:ajax_init_time),schema:metric,type:avg),(enabled:!t,id:'2',params:(drop_partials:!f,extended_bounds:(),field:'@timestamp',interval:h,min_doc_count:1,scaleMetricValues:!f,timeRange:(from:${urlParams.time},to:${urlParams.time == 'now%2Fd' ? 'now%2Fd' : 'now'}),useNormalizedEsInterval:!t),schema:segment,type:date_histogram),(enabled:!t,id:'3',params:(filters:!((input:(query:'file_name:%22selenium_diskfetcher_module_v2.rb%22'),label:''))),schema:group,type:filters)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),defaultYExtents:!f,dimensions:(series:!((accessor:1,aggType:filters,format:(),params:())),x:(accessor:0,aggType:date_histogram,format:(id:date,params:(pattern:'HH:mm')),params:(bounds:(max:'2021-09-27T11:39:18.587Z',min:'2021-09-27T07:39:18.587Z'),date:!t,format:'HH:mm',interval:PT5M,intervalESUnit:m,intervalESValue:5)),y:!((accessor:2,aggType:avg,format:(id:number),params:()))),drawLinesBetweenPoints:!t,grid:(categoryLines:!f),interpolate:linear,labels:(),legendPosition:right,radiusRatio:9,scale:linear,seriesParams:!((data:(id:'1',label:'Average+ajax_init_time'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,radiusRatio:9,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1)),setYExtents:!f,shareYAxis:!t,showCircles:!t,smoothLines:!f,thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:line,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(boundsMargin:0,defaultYExtents:!f,mode:normal,setYExtents:!f,type:linear),show:!t,style:(),title:(text:Count),type:value)),yAxis:()),title:'',type:line))&embed=true`} height="800" width="100%" className="border-0"></iframe>
          </TabPane>
        </TabContent>
      </CardBody>
    </Card>
  </Container>
}